export interface EloIconProps {
  width?: number
  height?: number
}
export const LOGO_VARIANTS = {
  large: 'L',
  medium: 'M',
  small: 'S',
} as const

export type LogoVariant = (typeof LOGO_VARIANTS)[keyof typeof LOGO_VARIANTS]

export const PAY_BY_BANK_COUNTRY_CODES = {
  DE: 'DE',
  FR: 'FR',
} as const

export type PayByBankCountryCode = (typeof PAY_BY_BANK_COUNTRY_CODES)[keyof typeof PAY_BY_BANK_COUNTRY_CODES] | ''
